<div *ngIf="simulationActive$ | async as simulationActive else listBlock">

  <app-simulation-header></app-simulation-header>

  <app-simulation-result *ngIf="simulationActive.status >= 0 && simulationActive.status !== 8 else detailBlock">
  </app-simulation-result>

  <ng-template #detailBlock>
    <app-simulation-detail></app-simulation-detail>
  </ng-template>
</div>

<ng-template #listBlock>
  <button class="app-block" mat-raised-button (click)="new()" [disabled]="isLoading$ | async" i18n>
    NEW
  </button>
  <button class="app-block" mat-raised-button (click)="duplicate()" i18n-title title="Duplicate Network"
    [disabled]="this.selecteds.length !== 1" i18n>
    DUPLICATE
  </button>
  <button class="app-block" *ngIf="simulations?.length > 0" mat-raised-button (click)="updateStatus()" i18n>
    UPDATE STATUS
  </button>

  <mat-selection-list (selectionChange)="selectionChange($event)" #selectionsList>
    <mat-list-option [value]="simulation" *ngFor="let simulation of simulations | orderBy: 'name'">
      <h4 mat-line (click)="$event.stopPropagation(); select(simulation.id)" i18n-title title="Open network">
        <app-simulation-status [simulationId]="simulation.id" [showText]="false">
        </app-simulation-status>
        <span fxFLex></span>
        <span *ngIf="simulation.status >= 0 else editBlock">{{simulation.name}}</span>
        <ng-template #editBlock>
          <i>{{simulation.name}}</i>
        </ng-template>
      </h4>
    </mat-list-option>
  </mat-selection-list>
</ng-template>

<app-loading *ngIf="isLoading$ | async"></app-loading>
